<template>
    <v-container class="fill-height" fluid>
        <v-container class="pa-0">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="6" lg="5" xl="4">
                    <v-form @submit.prevent="saveNewPassword">
                        <v-card>
                            <v-toolbar flat dark color="secondary">
                                <v-toolbar-title>Zmiana hasła</v-toolbar-title>
                            </v-toolbar>

                            <v-container>
                                <v-row justify="center">
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="newPassword"
                                            label="Nowe hasło"
                                            :type="showPassword ? 'text' : 'password'"
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            counter
                                            hint="Ilość znaków 8-20, duża litera, cyfra oraz znak specjalny."
                                            filled
                                            prepend-icon="mdi-lock"
                                            autocomplete="new-password"
                                            :error-messages="newPasswordErrors"
                                            @input="$v.newPassword.$touch()"
                                            @click:append="showPassword = !showPassword"
                                        />
                                        <v-text-field
                                            v-model="newPasswordConfirm"
                                            label="Powtórz hasło"
                                            :type="showPasswordRepeat ? 'text' : 'password'"
                                            :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                                            counter
                                            persistent-hint
                                            filled
                                            prepend-icon="mdi-lock"
                                            autocomplete="new-password"
                                            :error-messages="newPasswordConfirmError"
                                            @input="$v.newPasswordConfirm.$touch()"
                                            @click:append="showPasswordRepeat = !showPasswordRepeat"
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn
                                            type="submit"
                                            color="success"
                                            medium
                                            class="mt-1"
                                            data-sentry-label="Zaloguj"
                                            :loading="actionLoading"
                                        >
                                            Zmień hasło
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import router from '@/router'
import { errorHandler } from '@/utils/errorHandler'
import { required, sameAs } from 'vuelidate/lib/validators'
import { passwordRequirements } from '@/utils/customValidators'

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.token = to.query.token
        })
    },
    data() {
        return {
            newPassword: null,
            newPasswordConfirm: null,
            actionLoading: false,
            showPassword: false,
            showPasswordRepeat: false,
            token: null
        }
    },
    validations: {
        newPassword: {
            required,
            passwordRequirements,
        },
        newPasswordConfirm: {
            required,
            sameAsNewPassword: sameAs('newPassword')
        }
    },
    computed: {
        newPasswordErrors() {
            const errors = []

            if (!this.$v.newPassword.$dirty) return errors
            !this.$v.newPassword.required && errors.push('Proszę podać nowe hasło.')
            !this.$v.newPassword.passwordRequirements && errors.push('Hasło musi zawierać od 8 do 20 znaków, wielką literę, cyfrę oraz znak specjalny.')

            return errors
        },
        newPasswordConfirmError() {
            const errors = []

            if (!this.$v.newPasswordConfirm.$dirty) return errors
            !this.$v.newPasswordConfirm.required && errors.push('Proszę powtórzyć nowe hasło.')
            !this.$v.newPasswordConfirm.sameAsNewPassword && errors.push('Hasła nie są identyczne.')

            return errors
        },
    },
    methods: {
        saveNewPassword() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            const payload = {
                newPassword: this.newPassword,
                newPasswordConfirm: this.newPasswordConfirm,
                token: this.token
            }

            this.$store.dispatch('passwordReset', payload)
                .then(() => {
                    router.push({ name: 'userLogin' })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false,
                    this.newPassword = null,
                    this.newPasswordConfirm = null,
                    this.actionLoading = false,
                    this.showPassword = false,
                    this.showPasswordRepeat = false,
                    this.token = null
                })
        }
    }
}
</script>
